export default __webpack_public_path__ + "static/media/cow-three.e2f68109.webp";